import { useState, useCallback } from "react";

export type UseTitleEditingArgs = {
    onUpdateTitle: (slug: string, title: string) => void;
};

export const useTitleEditing = (args: UseTitleEditingArgs) => {
    const { onUpdateTitle } = args;

    const [editingTitle, setEditingTitle] = useState<{ slug: string; title: string } | null>(null);
    const [isTitleUpdating, setIsTitleUpdating] = useState(false);

    const startEditing = useCallback((slug: string, title: string) => {
        setEditingTitle({ slug, title });
    }, []);

    const cancelEditing = useCallback(() => {
        setEditingTitle(null);
    }, []);

    const updateEditingTitle = useCallback((title: string) => {
        setEditingTitle((prev) => (prev ? { ...prev, title } : null));
    }, []);

    const saveTitle = useCallback(async () => {
        if (!editingTitle) return;
        setIsTitleUpdating(true);
        try {
            await Promise.resolve(onUpdateTitle(editingTitle.slug, editingTitle.title));
            setEditingTitle(null);
        } catch (error) {
            console.error("Failed to update title:", error);
        } finally {
            setIsTitleUpdating(false);
        }
    }, [editingTitle, onUpdateTitle]);

    return {
        editingTitle,
        isTitleUpdating,
        startEditing,
        cancelEditing,
        updateEditingTitle,
        saveTitle,
        setEditingTitle,
    };
};
